import { render, staticRenderFns } from "./CardSpinner.vue?vue&type=template&id=aa605c0a&scoped=true&"
import script from "./CardSpinner.vue?vue&type=script&lang=js&"
export * from "./CardSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa605c0a",
  null
  
)

export default component.exports